<template>
  <div class="linksUser">
    <div class="container-fluid">
      <div class="card center card--flex">
        <div class="div__cont">
          <div class="div__btns" v-if="!hideButtonDashboard">
            <a
              v-if="!this.isAmbassador"
              class="btn__link"
              @click="this.updateStep"
            >{{translation.panel_bussiness}}</a>
          </div>
          <div
            class="input--out"
            v-bind:class="[hideButtonDashboard ? 'width-full-dashboard' : '']"
          >
            <span>{{translation.link}}</span>
            <input
              v-if="!step4"
              type="text"
              :value="this.generalLinkShare"
              id="general-share-link"
              class="general-input"
            >
            <input
              v-if="step4"
              type="text"
              :value="this.linkFunnel"
              id="general-share-link"
              class="general-input"
            >
            <div data-clipboard-target="#general-share-link" class="copy">
              <i class="fa fa-cut"></i>
              <a>{{translation.copy_link}}</a>
            </div>
          </div>
          <div v-if="(this.isAmbassador || this.isAmbassadorPlus) && this.hasTokenAvailable" class="ambassadors__links">
            <div
              class="input--out col-sm-10"
              v-for="(linkAmbassador, index) in this.allLinksAmbassador"
              :id="['js-ambassador-div-group-' + index]"
              :key="index"
              v-bind:class="[hideButtonDashboard ? 'width-full-dashboard' : '']"
            >
              <span>{{translation.link_ambassador}}</span>
              <input
                type="text"
                :value="linkAmbassador"
                :id="['general-ambassador-share-link-' + index]"
                class="general-input"
              >
              <div
                class="copy"
                :data-clipboard-target="['#general-ambassador-share-link-' + index]"
              >
                <i class="fa fa-cut"></i>
                <a>{{translation.copy_link}}</a>
              </div>
            </div>
            <div class="col-sm-2">
              <select
                class="select__lenguage"
                @change="handleLinkAmbassador"
                v-model="currencyLinkAmbassador"
              >
                <option value="USD">{{translation.usd}}</option>
                <option value="BRL">{{translation.brl}}</option>
                <option value="EUR">{{translation.eur}}</option>
              </select>
            </div>
            <div class="col-sm-12 info__token">
              <div v-if="ambassadorLimitTokens == 0">
                <span>{{translation.unlimited_token}}</span>
              </div>
              <div v-else>
                <span>{{translation.used_token}}</span>
                <span>{{ambassadorUsedTokens}}/{{ambassadorLimitTokens}}</span>
              </div>
            </div>
          </div>
          <div v-if="(this.isAmbassador || this.isAmbassadorPlus) && !this.hasTokenAvailable">
            <span class="limit__token__reached">{{translation.token_limit_reached}} - {{ambassadorUsedTokens}}/{{ambassadorLimitTokens}}</span>
          </div>
		   <div class="input--out" v-bind:class="[hideButtonDashboard ? 'width-full-dashboard' : '']" v-if="(this.isAmbassador || this.isAmbassadorPlus) && this.isBr && this.langBr == 'br'">
				<span>{{translation.link_ambassador_webinar}}</span>
				<input
				type="text"
				:value="this.linkWebinar"
				id="webinar-ambassador-share-link"
				class="general-input"
				>
				<div data-clipboard-target="#webinar-ambassador-share-link" class="copy">
					<i class="fa fa-cut"></i>
					<a>{{translation.copy_link}}</a>
				</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import merge from 'lodash-es/merge';

export default {
  name: "links-user",
  props: ["props", "isStep4", "funnel"],
  components: {},
  data() {
    return {
      generalLinkShare: null,
      isAmbassador: null,
      isAmbassadorPlus: null,
      allLinksAmbassador: [],
      ambassadorUsedTokens: null,
      ambassadorLimitTokens: null,
      hasTokenAvailable: false,
      ambassadorUsedTokens: null,
      currencyLinkAmbassador: "USD",
      translation: this.$parent.$parent.view.translation.linksUser,
      urls: this.$parent.$parent.view.urls,
      hideButtonDashboard: false,
      step4: false,
	  linkFunnel: null,
	  isBr: this.$parent.$parent.view.IS_BR,
	  langBr: this.$parent.$parent.view.lang,
	  linkWebinar: null
    };
  },
  methods: {
    handleLinkAmbassador() {
      if (this.currencyLinkAmbassador == "BRL")
        this.showAndHideAmbassadorsLinks("brl");
      if (this.currencyLinkAmbassador == "USD")
        this.showAndHideAmbassadorsLinks("usd");
      if (this.currencyLinkAmbassador == "EUR")
        this.showAndHideAmbassadorsLinks("eur");
    },
    showAndHideAmbassadorsLinks(linkToShow) {
      let brl = document.getElementById("js-ambassador-div-group-BRL");
      let usd = document.getElementById("js-ambassador-div-group-USD");
      let eur = document.getElementById("js-ambassador-div-group-EUR");
      brl.style.display = "none";
      usd.style.display = "none";
      eur.style.display = "none";
      if (linkToShow == "brl") brl.style.display = "flex";
      if (linkToShow == "usd") usd.style.display = "flex";
      if (linkToShow == "eur") eur.style.display = "flex";
    },
    updateStep() {
      this.$parent.nextStep();
    }
  },
  created() {
    if (this.isStep4) {
      this.step4 = this.isStep4;
      this.linkFunnel = `${this.funnel}#aid=${
        this.props.dados_usuario_office.id
      }`;
	}
	// https://office.builderall.com/us/franchise/share/186853?p1=rd&p2=https%3A%2F%2Fbr.erickambassadors.com%2F/
	this.linkWebinar = `https://office.builderall.com/br/franchise/share/${this.props.dados_usuario_office.id}/?p1=rd&p2=https%3A%2F%2Fbr.erickambassadors.com%2F/`;
  },
  mounted() {
    //ambassador info
    this.hasTokenAvailable = this.props.has_tokens_available;
    this.ambassadorUsedTokens = this.props.ambassador_used_tokens;
    this.ambassadorLimitTokens = this.props.ambassador_limit_tokens;
    this.generalLinkShare = this.props.link_user ? this.props.link_user : false;
    this.isAmbassador = this.props.IS_AMBASSADOR
      ? this.props.IS_AMBASSADOR
      : false;
    this.isAmbassadorPlus = this.props.IS_AMBASSADOR_PLUS
      ? this.props.IS_AMBASSADOR_PLUS
      : false;
    this.allLinksAmbassador = this.props.url_ambassador
      ? this.props.url_ambassador
      : false;

    this.hideButtonDashboard =
      document.location.pathname == this.urls.rota_dashboard &&
      this.$parent.$parent.stepIndex == 0;
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.linksUser {
  margin-left: 25px;

  .div__cont {
    max-width: 800px;
    width: 80%;
    min-width: 314px;
  }
  .container-fluid {
    padding-right: 0;
    padding-left: 0;

    .card {
      margin-bottom: 10px;
      margin-top: 17px;
    }
  }
  .in-line {
    display: flex;
    margin-bottom: 6px;
    width: 100%;
  }
  .div__btns {
    width: 100%;
    margin-bottom: 5px;
    .btn__link {
      align-items: center;
      justify-content: center;
      display: block;
      background: #0294ff;
      color: white;
      font-weight: 700;
      border-radius: 4px;
      -webkit-transition: 0.3s all;
      transition: 0.3s all;
      text-align: center;
      margin-right: 12px;
      height: 40px;
      display: flex;
      padding: 10px;
      font-size: 15px;
      align-items: center;
      cursor: pointer;
      width: 100%;
    }
  }
}
.info__token {
  span {
        color: #818a91;
      font-size: 15px;
    &:first-child {
      font-weight: 700;
    }
  }
}
.card--flex {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  // .width-full{
  //   width: 100%;
  // }
  .width-full-dashboard {
    width: 60%;
  }
  .input--out {
    border: 1px solid #0294ff;
    // padding: 0.6rem 1rem;
    border-radius: 8px;
    display: flex;
    align-items: center;
    color: #818a91;
    // margin: 0.6rem 0;
    height: 40px;
    font-size: 15px;
    padding: 0 5px 0 5px;
    margin-bottom: 5px;
    position: relative;
    justify-content: space-evenly;
    span {
      font-weight: 700;
      font-size: 15px;
    }

    .copy {
      // float: right;
      // position: absolute;
      // right: 10px;
    }
    .general-input {
      width: 45%;
    }

    input {
      border: 0;
      margin: 0 0.8rem;
      padding: 0;
      &:focus {
        padding: 0;
        outline: none;
      }
    }
    a {
      margin-left: 3px;
      color: #818a91;
      font-weight: 100;
    }
  }
  .ambassadors__links {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    .select__lenguage {
      margin-left: 4px;
      padding: 0rem;
      border: 1px solid #0294ff;
      padding: 0.6rem 1rem;
      border-radius: 7px;
      color: #818a91;
      font-weight: 700;
      font-size: 15px;
      text-transform: uppercase;
      height: 40px;
      margin-bottom: 5px;
      &:focus {
        overflow: auto;
        outline: none;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
      }
    }
  }
  .limit__token__reached {
    font-weight: 700;
    font-size: 15px;
    color: #818a91;
  }
  #js-ambassador-div-group-BRL,
  #js-ambassador-div-group-EUR {
    display: none;
  }
}
@media (max-width: 1150px) {
  .linksUser {
    margin: 0;
  }
  .linksUser .div__cont {
    max-width: unset;
    width: 100%;
  }
  .card--flex .input--out {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise/components/linksUser.vue